module.exports = "<div>\n    <ng-progress [color]=\"'#24b0bf'\" [showSpinner]=\"false\"></ng-progress>\n    <div *ngIf=\"showOverlay\" class=\"loader-overlay\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/loadingBar/loader.html
// module id = ./src/app/common/loadingBar/loader.html
// module chunks = main